export const PRODUCT_IDENTITY = Object.freeze({
  name: 'Learnitive',
  shortName: 'Learnitive',
  domain: 'learnitive.com',
  origin: 'https://www.learnitive.com',
  docsUrl: 'https://www.learnitive.com/docs',
  supportUrl: 'https://www.learnitive.com/contact',
  protocol: 'web+learnitive',
  storagePrefix: 'learnitive:',
} as const);
